import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createVNode as _createVNode, unref as _unref, createBlock as _createBlock, withModifiers as _withModifiers, TransitionGroup as _TransitionGroup, withCtx as _withCtx, isRef as _isRef, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4722be52"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "container",
  class: "vtl-container"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sticky" }, null, -1))
const _hoisted_3 = { class: "vtl-table" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["colspan"]
const _hoisted_6 = {
  key: 0,
  class: "vtl-checkbox"
}
const _hoisted_7 = ["disabled", "checked"]
const _hoisted_8 = {
  key: 1,
  class: "vtl-thead vtl-td-checkbox"
}
const _hoisted_9 = { class: "vtl-header-filter-wrapper" }
const _hoisted_10 = { class: "vtl-header-wrapper" }
const _hoisted_11 = { class: "vtl-header" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  class: "tail"
}
const _hoisted_14 = {
  key: 0,
  class: "vtl-filter"
}
const _hoisted_15 = { class: "vtl-filter-title" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Filter:", -1))
const _hoisted_17 = ["onSubmit"]
const _hoisted_18 = ["disabled", "value"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", null, "Ok", -1))
const _hoisted_20 = ["value", "disabled", "onInput"]
const _hoisted_21 = {
  key: 0,
  class: "vtl-loading-err"
}
const _hoisted_22 = ["colspan"]
const _hoisted_23 = {
  key: 1,
  class: "vtl-empty-msg"
}
const _hoisted_24 = ["colspan"]
const _hoisted_25 = ["onClick", "title"]
const _hoisted_26 = ["value", "disabled", "checked", "onChange"]
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { key: 2 }
const _hoisted_30 = {
  key: 0,
  class: "summary-cell"
}
const _hoisted_31 = { class: "bold-summary" }
const _hoisted_32 = {
  key: 1,
  class: "summary-cell"
}
const _hoisted_33 = { class: "bold-summary" }
const _hoisted_34 = {
  key: 2,
  class: "summary-cell"
}
const _hoisted_35 = {
  key: 0,
  class: "vtl-paging"
}
const _hoisted_36 = { class: "vtl-paging-info col-md-4" }
const _hoisted_37 = {
  role: "status",
  "aria-live": "polite",
  class: "vtl-paging-span"
}
const _hoisted_38 = { class: "vtl-pagination col-md-4" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "«", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Previous", -1))
const _hoisted_41 = [
  _hoisted_39,
  _hoisted_40
]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "1", -1))
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = {
  key: 0,
  class: "page-item"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "page-link placeholder",
  "aria-label": "..."
}, [
  /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "...")
], -1))
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = {
  key: 1,
  class: "page-item"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "page-link placeholder",
  "aria-label": "..."
}, [
  /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "...")
], -1))
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = { "aria-hidden": "true" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "»", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Next", -1))
const _hoisted_54 = [
  _hoisted_52,
  _hoisted_53
]
const _hoisted_55 = { class: "vtl-paging-count" }
const _hoisted_56 = ["value"]
const _hoisted_57 = { class: "vtl-paging-page" }
const _hoisted_58 = ["value"]
const _hoisted_59 = {
  key: 1,
  class: "vtl-paging"
}
const _hoisted_60 = { class: "vtl-paging-info col-md-4" }
const _hoisted_61 = {
  role: "status",
  "aria-live": "polite",
  class: "vtl-paging-span"
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "vtl-pagination col-md-4" }, null, -1))
const _hoisted_63 = { class: "vtl-paging-count" }
const _hoisted_64 = ["value"]
const _hoisted_65 = { class: "vtl-paging-page" }
const _hoisted_66 = ["value"]
const _hoisted_67 = {
  key: 2,
  class: "vtl-paging"
}
const _hoisted_68 = {
  key: 0,
  class: "vtl-paging-info col-md-4"
}
const _hoisted_69 = {
  role: "status",
  "aria-live": "polite",
  class: "vtl-paging-span"
}

import { ref, Ref, computed, ComputedRef, onMounted, onUnmounted, watch, inject } from 'vue';
import ScrollToTopButton from './ScrollToTopButtonLite.vue';
import { ArrowState } from '@/types/enums/ArrowState';
import Spinner from './Spinner.vue';
import Sorter, { DisplayableKeys } from '@/services/SorterService';
import CancellablePromise, { PromiseCancelledError } from '@/types/CancellablePromise';
import PropCaseHelper from '@/services/helpers/PropCaseHelper';
import { loggerKey } from '@/types/ServiceKeys';
import useVModelDefaultVar from '@/services/composables/VModelDefaultVar';
import MultiStateSVGButton from './common/MultiStateSVGButton.vue';
// SVG
import ArrowUpDown from './svg/ArrowUpDown.vue';
import Filter from './svg/Filter.vue';
import Circle from './svg/Circle.vue';
import FilledCircle from './svg/FilledCircle.vue';
import MaskedTransition from './svg/MaskedTransition.vue';
import IFilter from '@/Interfaces/IFilter';
import {  MonetaryValueWithCommas } from "@/services/helpers/Helper";
export type KeyTypeKeys<T, K extends keyof T=keyof T> = K extends any ? T[K] extends (string|number) ? K : never : never;
export type CheckRet<T, K extends KeyTypeKeys<T> | undefined, P extends boolean | undefined> = 
    K extends keyof T
        ? P extends true 
            ? T[K][]
            : T[]
        : T[];
export interface ITableProps<T,K extends KeyTypeKeys<T> | undefined=undefined,P extends boolean | undefined=undefined> {
    /**
    *  An array of T typed objects for displaying on the table
    */
    Rows: T[]|undefined; //can be updated by parent
    /**
    *  An array containing field names of T, or subarrays
    *   of field names if the cell uses multiple field of data
    *   when sorting, the last element is the most important
    * 
    *  example: if T has 'arms': Array<Arm>,'legs': Array<Leg>,'head': Head
    *  you can pass ['arms',['legs','head']]
    */
    Cols: DisplayableKeys<T>[];
    /**
     * The column headings you want to show on the table for each column
     * If the length doesn't match that of Cols, will show the field
     * names defined in Cols instead
    */
    Labels?: string[];
    /**
     * cols that need to be of min width
     */
    ColsMinWidth?: number[];
    /**
     * The unique key of each row for accessing rows
     * defined this to make checking persistent across data refresh (Rows getting reassigned)
     * If LoadDataCallback is defined, data refresh occurs at filtering and page change as well
    */
    ColKey?: K;
    //disabling type checking for ColKey because of vue bug.
    //ColKey?: keyof T;
    /**
     * Set to sort this column in ascending order by default if possible
     * must be an numeric index value
     */
    DefaultSortCols?: number[];
    /**
     * An array of 1 or -1 to indicate sort order of respective column
     * 1 for ascending and -1 for descending
     */
    DefaultSortOrders?: Array<-1 | 1>;
    NonFilterableColumns?: (keyof T)[];
    /**
     * When set to true show banner about loading error and disable all table displays
     */
    HasError?: unknown;
    /**
     * If true, show an extra column of checkboxes to the left
     * 
     * Default is false.
     */
    HasCheckBox?: boolean;
    /**
     * If true, adds an extra column in front. Customize header with the slot pre-col-header and the row with pre-col
     * 
     * Default is false.
     */
    HasPreCol?: boolean;
    /** Number of rows per page
     * A v-model. Number of rows per page when the page is displayed.
     * (The user may have a preference saved, pass it here)
     *
     * Default is 40.
     */
    RowsPerPage?: number;
    // data passed in may only be a subset of the total number of records
    /**
     * The total number of records for the current query from the database
     * for calculating number of pages. When data is fully loaded, you
     * can just pass Rows.length. Otherwise pass the number the server returns.
     */
    NumRecords?: number; //can be updated by parent
    //assumes when NumRecords!=Rows.length, needs to be dynamically loaded
    /**
     * Do I return the reference to checked rows or just the keys of those rows
     * If key is not defined, return entire row even if true.
     * 
     * Default is false. 
     */
    ReturnKey?: P;
    /** The current page the table is on.
     * A v-model. Change when user switches page using the pagination
     * buttons. Also gets reset when assigning new data in normal mode.
     * In callback mode, it only goes back to the maximum page when
     * the number of rows change to a lower number.
     * 
     * default is 1
     */
    Page?: number;
    /**
     * If true, disable sorting functionality
     */
    DisableSort?: boolean;
    DisableFilter?: boolean;
    /**
     * Array of page numbers to show on the screen for the dropdown box.
     * 
     * Default is [20,50,100].
     */
    PageOptions?: number[];
    ShowTableCount?: boolean;
    /**
     * Message to show when items have been checked. {0} for the number of items checked.
     */
    CheckedInfoMessage?: string;
    /**
     * The message displayed on the bottom left corner
     * {0} is the starting row on display, {1} is the last row on display
     * {2} is the current page
     * 
     * Default message is Showing {0}-{1} of {2}
     */
    PagingInfoMessage?: string;
    /**
     * The label in front of the dropdown box of page
     * 
     * Default is Row count:
     */
    PageSizeChangeLabel?: string;
    GotoPageLabel?: string;
    NoDataAvailableMessage?: string;
    /**
     * If true, hides the table but leaves the headings untouched
     */
    HideTable?: boolean;
    /**
     * Number of pagination buttons aside from the first, last page buttons
     */
    NumPaging?: number;
    RowTitle?: (item: T)=>string;
    TableName?: string;
    /** 
     * Make check all button to include items on other pages
     * Ignored when LoadDataCallback is defined, define ColKey instead to preserve checked items
     */
    CheckIncludesNonDisplayed?: boolean;
    SummaryCols?: DisplayableKeys<T>[];
    SummaryValues?: number[];
    SummaryLabel?: string;
    CheckByDefault?: boolean;
    DisableCheckPersistentAcrossRefresh?: boolean;
    SplitColKeys?: boolean;
    ShowHeaderWhileLoading?: boolean;
    /** Hides rows beyond rows per page */
    DisablePaging?: boolean;
    MiniPaging?: boolean;
    /** @deprecated */
    SingleSelection?: boolean;
    RowCheckableFilter?: (row: T)=>boolean;
    /** Callback when checking or unchecking stuff
     * @row is the checked rows
     */
    CheckCallBack?: (row: CheckRet<T,K,P>)=>void;
    /**
     * define this to allow rows to be clicked
     * set to undefined if don't want rows to be clickable
     */
    RowClickedCallBack?: ((row: T) => void);
    // method to obtain the data, add filter and other options in the future?
    // or just make it a callback, data handled by parent component? if callback is null, it is static?
    // 1 means ascending, -1 for descending
    LoadDataCallBack?: ((offset: number, count: number, sortCols: number[], sortOrders: (-1 | 1)[], filter?: IFilter<T>) => CancellablePromise<void>);
    ColumnGroups?: { header: string; columns: string[] }[];}
export interface WrappedRow<T> {
    checked: boolean;
    value: T;
}
export interface ITableExpose<T,K extends KeyTypeKeys<T> | undefined=undefined,P extends boolean | undefined=undefined> {
    LoadData: ()=>void;
    GetChecked: ()=>CheckRet<T,K,P>;
    CheckAll: ()=>void;
    ClearChecked: ()=>void;
    ResetSort: ()=>void;
    ResetFilter: ()=>void;
    GetFiltered: ()=>T[];
}
export interface ITableEmit {
    (e: 'update:HasError', value: unknown);
    (e: 'update:Page', value: number);
    (e: 'update:RowsPerPage', value: number);
    // disabled because the condition for checking checks cleared needs a fix
    //(e: 'clear');
    (e: 'check');
    (e: 'uncheck');
}
enum NullFilterState {
    Off,
    NullOnly,
    NonNullOnly,
}
type NonNullableK<T, K extends keyof T | undefined> = K & keyof T;

export default /*#__PURE__*/_defineComponent({
  __name: 'TablePersistentChecking',
  props: {
    Rows: {},
    Cols: {},
    Labels: {},
    ColsMinWidth: {},
    ColKey: {},
    DefaultSortCols: {},
    DefaultSortOrders: {},
    NonFilterableColumns: {},
    HasError: {},
    HasCheckBox: { type: Boolean },
    HasPreCol: { type: Boolean },
    RowsPerPage: {},
    NumRecords: {},
    ReturnKey: {},
    Page: {},
    DisableSort: { type: Boolean },
    DisableFilter: { type: Boolean },
    PageOptions: { default: () => [20, 40, 100] },
    ShowTableCount: { type: Boolean },
    CheckedInfoMessage: { default: 'You have checked {0} item(s). Click here to uncheck all.' },
    PagingInfoMessage: { default: 'Showing {0}-{1} of {2} item(s)' },
    PageSizeChangeLabel: { default: 'Row count:' },
    GotoPageLabel: { default: 'Go to page:' },
    NoDataAvailableMessage: { default: 'No data' },
    HideTable: { type: Boolean },
    NumPaging: { default: 5 },
    RowTitle: {},
    TableName: {},
    CheckIncludesNonDisplayed: { type: Boolean },
    SummaryCols: {},
    SummaryValues: {},
    SummaryLabel: {},
    CheckByDefault: { type: Boolean },
    DisableCheckPersistentAcrossRefresh: { type: Boolean },
    SplitColKeys: { type: Boolean },
    ShowHeaderWhileLoading: { type: Boolean },
    DisablePaging: { type: Boolean },
    MiniPaging: { type: Boolean },
    SingleSelection: { type: Boolean },
    RowCheckableFilter: {},
    CheckCallBack: {},
    RowClickedCallBack: {},
    LoadDataCallBack: {},
    ColumnGroups: {}
  },
  emits: ["update:HasError", "update:Page", "update:RowsPerPage", "check", "uncheck"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const nullFilterSVGs = [MaskedTransition,Circle,FilledCircle];
const nullFilterBtnTitles = ['Not filtering, click to toggle to filter for blanks', 'Showing only blanks, click to toggle to filter for non-empty', 'Showing only non-empty values, click to toggle off the filter'];

const emits = __emit;
const props = __props;
const nullFilterStates: Ref<Partial<Record<DisplayableKeys<T>, NullFilterState>>> = ref({});
const filter: Ref<Partial<Record<DisplayableKeys<T>, string>>> = ref({});
const filterShown = ref<number>();
const log = inject(loggerKey);
const isLoading = ref(true);
const page = useVModelDefaultVar(props as ITableProps<T,K,P>, emits, 'Page', 1, pageChangeCallBack);
const numRecords = computed(() => 
    props.LoadDataCallBack ? props.NumRecords ?? 0 :
        filteredRows.value.length
);
const nDisplayCols = computed(()=>props.Cols.length + 20);
const labels = computed(()=>
    (!props.Labels||props.Labels.length!==props.Cols.length) ? 
        props.SplitColKeys ? props.Cols.map(x=>splitColKeyWords(x)) : props.Cols.map(x=>x.toString())
        : props.Labels);
const rowsPerPage = useVModelDefaultVar(props as ITableProps<T,K,P>, emits, 'RowsPerPage', 40);
const rowsPerPageInitial = ref(rowsPerPage.value);
/** when LoadCallBack is defined or CheckIncludesNonDisplayed is false
 * This is just the counter for numbers items checked on the current page
 * otherwise, it's number of checked items in filteredRows
 */
const checkCounter = ref(0);
const rowStart = computed(() => (page.value - 1) * rowsPerPage.value + 1);
const rowEnd = computed(() => {
    const limit = rowStart.value + rowsPerPage.value - 1;
    const n = numRecords.value ?? 0;
    const result = n >= limit ? limit : n;
    //log?.debug(`rowEnd updated: ${result}`);
    return result;
});
const maxPage = computed(() => {
    const n = numRecords.value ?? 0;
    if (n <= 0) return 1;
    const maxP = Math.ceil(n / rowsPerPage.value);
    //log?.debug(`maxP updated: ${maxP}`);
    if (maxP < page.value) page.value = maxP;
    return maxP;
});
//const maxPage = ref(3);
const pageSwitch = computed(() => {
    let num = props.NumPaging;
    const half = Math.floor(num / 2);
    let start = page.value - half; //to be a dynamic value based on page width
    start = (start < 1) ? 1 : start;
    if (start <= 2) {
        num += 1;
        if (start == 1) start += 1;
    }
    let end = start + num - 1;
    if (end == maxPage.value - 2) {
        end = maxPage.value - 1;
    }
    else if (end >= maxPage.value) {
        end = maxPage.value - 1;
        num += 1;
        start = end - num + 1;
        start = start < 2 ? 2 : start;
    }
    num = end - start + 1;
    const results = { start, end, num };
    //log?.debug(`pageSwitch updated: `);
    //log?.debug(results);
    return results;
});
const allChecked = computed(isAllChecked);
const nothingToCheck = computed(()=>getCheckableCount()<=0);
const sortCols = ref(props.DefaultSortCols ?? [] as number[]);
const sortOrders = ref(getDefaultSortOrder());
const wrappedRows: Ref<WrappedRow<T>[]> = ref([]);
const sortedRows: Ref<WrappedRow<T>[]> = ref([]);
const filteredRows: Ref<WrappedRow<T>[]> = ref([]);
const pageRows: ComputedRef<WrappedRow<T>[]> = computed(() =>
    props.LoadDataCallBack ? wrappedRows.value : filteredRows.value.slice(rowStart.value - 1, rowEnd.value)
);
const minWidthCols = computed(() => {
    if (props.ColsMinWidth) {
        const result = new Array<boolean>(props.Cols.length);
        result.fill(false);
        props.ColsMinWidth.forEach(i => { result[i] = true; });
        return result;
    } else return undefined;
});
const overflow = ref(false);
const sticky = ref(false);
const slotKeys = computed(getSlotNames);
const showPagingInfo = computed(() => {
    return maxPage.value > 1 && !(props.HideTable || showingLoading.value || props.DisablePaging);
});
const err = useVModelDefaultVar(props,emits,'HasError',false);
const showingFullTable = computed(()=>err.value || !isLoading.value || props.ShowHeaderWhileLoading);
const showingLoading = computed(()=>!(err.value || !isLoading.value));
//const showingFullTable = false;
//const showingLoading = true;
const detector = ref<HTMLElement>();
const checkedItems: Ref<Map<T[NonNullableK<T,K>], T> | undefined> = ref();
const numChecked = computed(() => {
    return getChecked().length;
});
let callBackPromise: CancellablePromise | undefined;
let observer: IntersectionObserver | undefined;

__expose<ITableExpose<T,K,P>>({
    LoadData: resetPage, GetChecked: getChecked, ClearChecked: uncheckAll, ResetSort: resetSort, ResetFilter: resetFilter, CheckAll: checkAll, GetFiltered: getFiltered
});
watch(()=>props.Rows, assignLocalRows);
watch(()=>props.Cols, onChangeCols);
watch(pageRows, updateCheckCounter);
onMounted(() => {
    if (!loadDataIfCallBack()) assignLocalRows(props.Rows);
    window.addEventListener("resize", updateTablePosition);
    if (!detector.value) return console.log('detector not mounted! Report to vue team!');
    const stickyEl = detector.value.parentElement?.children[1];
    observer = new IntersectionObserver((e) => {
        //log?.debug('header intersection: ',e[0].intersectionRatio, e[0].boundingClientRect.bottom, stickyEl?.getBoundingClientRect?.().top, stickyEl);
        if (e[0].intersectionRatio === 0 && 
            e[0].boundingClientRect.bottom < (stickyEl?.getBoundingClientRect?.()?.top ?? 0)) {
            sticky.value = true;
        }
        else {
            sticky.value = false;
        }
    });
    observer.observe(detector.value);
});
onUnmounted(() => {
    window.removeEventListener("resize", updateTablePosition);
    observer?.disconnect();
    observer = undefined;
});
function onChangeCols(newCols: Array<keyof T | (keyof T)[]>, oldCols: Array<keyof T | (keyof T)[]>) {
    filterShown.value = undefined;
    updateSort(newCols, oldCols);
}
function updateSort(newCols: Array<keyof T | (keyof T)[]>, oldCols: Array<keyof T | (keyof T)[]>) {
    const flatNewColsMap = new Map(newCols.map((x, idx) => [x instanceof Array ? x.join('_') : x, idx]));
    const flatOldCols = oldCols.map(x => x instanceof Array ? x.join('_') : x);
    
    const combined = sortCols.value.map((i,ord) => [flatNewColsMap
        .get(flatOldCols[i]), sortOrders.value[ord]])
        .filter((x): x is [number,-1|1] => x[0] !== undefined);
    
    sortCols.value = combined.map(x => x[0]);
    sortOrders.value = combined.map(x => x[1]);
    sortedRows.value = sortRows(wrappedRows.value);
    applyFilter();
    //log?.debug("tablelite resetSort()",sortCols.value, sortOrders.value)
}
function access(item:T, key:keyof T) {
    const v = item[key];
    return (v instanceof Function) ? v.call(item) : v;
}
function assignLocalRows(rows: T[]|undefined, oldRows?: T[]) {
    isLoading.value = true;
    if (!rows) return;
    if (!(rows.length||oldRows?.length!==0)) { isLoading.value = false; return; }
    log?.debug('loading props.Rows into localRows\n','new:',rows,'\nold:',oldRows);
    const key = props.ColKey;
    wrappedRows.value = wrapRows(rows);
    if (key && props.DisableCheckPersistentAcrossRefresh) {
        // removing items that don't exist in current data
        checkedItems.value = new Map(wrappedRows.value.map(x=>[x.value[key], x.value]));
    }
    if (!props.LoadDataCallBack) {
        resetPage();
        sortedRows.value = sortRows(wrappedRows.value);
        applyFilter();
    }
    if (key && props.CheckByDefault) {
        if (oldRows) {
            const set = new Set(oldRows.map(x=>x[key]));
            const rowsToCheck = wrappedRows.value.filter(x=>!set.has(x.value[key])&&!x.checked);
            checkRows(rowsToCheck);
        } else {
            checkRows(wrappedRows.value);
        }
    }
    isLoading.value = false;
    setTimeout(() => {
        //log?.debug(`getLocalRows() ticking. changing loading state to: false`);
        //log?.debug(localRows.value);
        updateTablePosition();
    }, 0);
}
function wrapRows(rows: T[]) {
    if (props.ColKey && checkedItems.value) {
        const k = props.ColKey;
        const checked = checkedItems.value;
        const results = rows.map((row: T) => {
            return { value: row, checked: checked.has(row[k]), } as WrappedRow<T>;
        });
        return results;
    }
    return rows.map((row: T) => {
            return { value: row, checked: false, } as WrappedRow<T>;
        });
}
function isSortKeyByDefault(colKey?: keyof T) : colKey is K & DisplayableKeys<T> {
    if (colKey) {
        if(colKey !== props.ColKey) throw new Error('input must be ColKey');
    } else {
        colKey = props.ColKey;
    }
    return (!!colKey && !props.Cols.some(a=>a === colKey));
}
function getSortingKeys() {
    const k = props.ColKey;
    const base = sortCols.value.flatMap(i=>props.Cols[i]);
    //console.log('getSortingKeys',base);
    const result = isSortKeyByDefault(k) ? [...base,k] : base;
    return  result;
}
function getSortingOrders(): (-1|1)[] {
    const ordersMapped = sortCols.value.flatMap((colIdx,sortIdx)=> {
        const keys = props.Cols[colIdx];
        return (keys instanceof Array) ? keys.map(_=>sortOrders.value[sortIdx]) : sortOrders.value[sortIdx];
    });
    //console.log('getSortingOrders',ordersMapped);
    return isSortKeyByDefault() ? [...ordersMapped,1] : ordersMapped;
}
function sortRows(rows: WrappedRow<T>[]) {
    //sort it locally if there is no callback to get sorted data
    /* // refs https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Collator/compare
        const collator = new Intl.Collator('en-GB', {
        numeric: true,
        sensitivity: "base",
        }); */
    const sortColKeys = getSortingKeys();
    const sortOrders = getSortingOrders();
    if (sortColKeys.length > 0) {
        rows = [...rows].sort((a, b): number =>
            Sorter.CompareObjectWithMultipleKeys(a.value, b.value, sortColKeys, sortOrders));
        //console.log('sorted rows', rows, sortColKeys, sortOrders)
    }
    return rows;
}
function getDefaultSortOrder(): Array<1 | -1> {
    if (props.DefaultSortOrders) {
        if (props.DefaultSortOrders.length === props.DefaultSortCols?.length) {
            return props.DefaultSortOrders;
        }
    }
    return props.DefaultSortCols ?
        Array(props.DefaultSortCols.length).fill(1) :
        [] as Array<1 | -1>;
}
function updateTablePosition() {
    overflow.value = checkXOverflow();
    //log?.debug(`position updated. bottom: ${headerBot.value}. Is overflowing: ${overflow.value}`);
}
function checkXOverflow() {
    const cont = detector.value?.parentElement?.parentElement;
    return (cont?.clientWidth ?? 0) < (cont?.scrollWidth ?? 0);
}
function getCheckableCount() {
    const rowsToCheck = props.CheckIncludesNonDisplayed && !props.LoadDataCallBack ? filteredRows.value : pageRows.value;
    const filter = props.RowCheckableFilter;
    if (filter) return rowsToCheck.filter(x=>filter(x.value)).length;
    else return rowsToCheck.length;
}
function isAllChecked(): boolean {
    const n = getCheckableCount();
    return n > 0 && checkCounter.value >= n;
}
/** @deprecated */
function updateSingleCheck(row: WrappedRow<T>) {
    if (row.checked) {
        row.checked = false;
        if (props.ColKey) {
            checkedItems.value?.delete(row.value[props.ColKey]);
        }
        emits('uncheck');
    } else {
        uncheckAll();
        row.checked = true;
        if (props.ColKey) {
            if (!checkedItems.value) {
                checkedItems.value = new Map<T[NonNullableK<T,K>], T>();
            }
            checkedItems.value.set(row.value[props.ColKey],row.value);
        }
        emits('check');
    }
    props.CheckCallBack?.(getChecked());
}
/**
 * unchecks items across all pages (only filtered ones)
 */
function uncheckAll() {
    checkedItems.value?.clear();
    filteredRows.value.forEach(row => row.checked = false);
    checkCounter.value = 0;
    props.CheckCallBack?.(getChecked());
    //emits('clear');
}
function uncheckAllShown() {
    if (props.ColKey) {
        const key = props.ColKey;
        pageRows.value.filter(r=>r.checked).forEach(row => row.checked ? checkedItems.value?.delete(row.value[key]) : null);
    }
    let oldCounter = checkCounter.value;
    pageRows.value.forEach(row => { 
        if (row.checked) {
            oldCounter--;
            row.checked = false;
        }
    });
    checkCounter.value = oldCounter;
    props.CheckCallBack?.(getChecked());
    //if (oldCounter <= 0) emits('clear');
}
function checkRows(rowsToCheck: WrappedRow<T>[]) {
    if (props.RowCheckableFilter) {
        const filter = props.RowCheckableFilter;
        rowsToCheck.filter(x=>filter(x.value)).forEach(row => { row.checked = true; });
    }
    else rowsToCheck.forEach(row => { row.checked = true; });
    if (props.ColKey) {
        if (!checkedItems.value) {
            checkedItems.value = new Map<T[NonNullableK<T,K>], T>();
        }
        for (const row of rowsToCheck) {
            row.checked ? checkedItems.value.set(row.value[props.ColKey],row.value) : null;
        }
    }
    const oldCount = checkCounter.value;
    checkCounter.value = getCheckableCount();
    if (checkCounter.value > oldCount) emits('check');
    props.CheckCallBack?.(getChecked());
}
function checkAll() {
    if (isAllChecked()) props.CheckIncludesNonDisplayed ? uncheckAll() : uncheckAllShown();
    else {
        const rowsToCheck = props.CheckIncludesNonDisplayed && !props.LoadDataCallBack ? filteredRows.value : pageRows.value;
        checkRows(rowsToCheck);
    }
}
function checkRow(row: WrappedRow<T>) {
    if (row.checked) {
        row.checked = false;
        checkCounter.value -= 1;
        if (props.ColKey) {
            checkedItems.value?.delete(row.value[props.ColKey]);
        }
        //if (checkCounter.value === 0) emits('clear');
        //else
        emits('uncheck');
    } else {
        row.checked = true;
        checkCounter.value += 1;
        if (props.ColKey) {
            if (!checkedItems.value) {
                checkedItems.value = new Map<T[NonNullableK<T,K>], T>();
            }
            checkedItems.value.set(row.value[props.ColKey],row.value);
        }
        emits('check');
    }
    props.CheckCallBack?.(getChecked());
}
function getChecked() {
    const results = (props.HasCheckBox ? props.ColKey ? props.ReturnKey ? filterCheckedItems().map(x=>x[0]) :
        filterCheckedItems().map(x=>x[1]) :
        (props.CheckIncludesNonDisplayed ?  filteredRows.value : pageRows.value).filter(a => a.checked).map(a => a.value) :
        []
    ) as CheckRet<T,K,P>;
    //log?.debug(getChecked.name, results);
    return results;
}
function getFiltered(){
    return filteredRows.value.map(x=>x.value);
}
function updateCheckCounter() {
    if (props.HasCheckBox) {
        if (props.CheckIncludesNonDisplayed && !props.LoadDataCallBack) {
            checkCounter.value = filteredRows.value.reduce((count,x)=>x.checked?count+1:count,0);
        } else {
            checkCounter.value =  pageRows.value.reduce((count,x)=>x.checked?count+1:count,0);
        }
        props.CheckCallBack?.(getChecked());
    }
}
function updateSorted() {
    if (!loadDataIfCallBack()) {
        isLoading.value = true;
        sortedRows.value = sortRows(wrappedRows.value);
        applyFilter();
        isLoading.value = false;
    }
}
function sortBy(colIndex: number) {
    if (props.DisableSort) return;
    const idx = sortCols.value.indexOf(colIndex);
    if (idx >= 0) {
        if (sortOrders.value[idx] < 0) {
            sortCols.value.splice(idx, 1);
            sortOrders.value.splice(idx, 1);
        }
        else sortOrders.value[idx] = -1;
    } else {
        sortCols.value.unshift(colIndex);
        sortOrders.value.unshift(1);
    }
    updateSorted();
}
function stringFormat(template: string, ...args: any[]) {
    return template.replace(/{(\d+)}/g, function (match, number) {
        return typeof args[number] != "undefined" ? args[number] : match;
    });
}
function updatePage() {
    if (page.value > maxPage.value) page.value = maxPage.value > 0 ? maxPage.value : 1;
}
function clearCallbackRef() {
    callBackPromise = undefined;
}
function getFilterRequest() {
    const nullFilterVals = Object.entries(nullFilterStates.value).filter(([k,v])=>v!=NullFilterState.Off).map(
        ([k,v])=>v===NullFilterState.NullOnly?[`${k}NullsOnly`,""]:[k,""]
    );
    const filteredFilter = Object.fromEntries(Object.entries(filter.value).filter(([k,v])=>v));
    const filterReq = Object.assign(Object.fromEntries(nullFilterVals), filteredFilter);
    return filterReq;
}
function loadDataIfCallBack() {
    //log?.debug('---loadDataIfCallBack---');
    if (props.LoadDataCallBack) {
        const promise = props.LoadDataCallBack(rowStart.value-1,
            rowsPerPage.value,
            sortCols.value,
            sortOrders.value,
            getFilterRequest()
        );
        if (callBackPromise) callBackPromise.cancel();
        isLoading.value = true;
        callBackPromise = promise.then(() => {
            clearCallbackRef();
            updateTablePosition();
            updatePage();
        }, e=>{
            if (!(e instanceof PromiseCancelledError)) {
                err.value = e;
            }
        }) as CancellablePromise<void>;
        //log?.debug('---loadDataIfCallBack returns true---');
        return true;
    }
    //log?.debug('---loadDataIfCallBack returns false---');
    return false;
}
function pageChangeCallBack() {
    if (page.value > maxPage.value) page.value = maxPage.value;
    else loadDataIfCallBack();
}
function prevPage(): boolean {
    if (page.value == 1) return false;
    page.value--;
    return true;
}
function nextPage(): boolean {
    if (page.value >= maxPage.value) return false;
    page.value++;
    return true;
}
function movePage(p: number) {
    page.value = p;
}
function resetPage() {
    page.value = 1;
}
function disableEventPropagation(e: Event) {
    if (e.stopPropagation) {
        e.stopPropagation();
    } else if (window.event) {
        window.event.cancelBubble = true;
    }
}
function colKeyToName(col: keyof T | (keyof T)[]) {
    return Array.isArray(col) ? col.join('-') : (col as string);
}
function getSlotNames() {
    const results = new Array<string>(props.Cols.length);
    const counts: Record<string, number> = {};
    props.Cols.forEach((v, i) => {
        const newKey = colKeyToName(v);
        if (counts[newKey]) {
            results[i] = `${newKey}-${counts[newKey]++}`;
        }
        else {
            results[i] = newKey;
            counts[newKey] = 1;
        }
    });
    return results;
}
function seperateVarNameWords(str: string) {
    return PropCaseHelper.toSentenceName(str);
}
function splitColKeyWords(col: keyof T | (keyof T)[]) {
    if (col instanceof Array) {
        return seperateVarNameWords(col.join('-'));
    } else if (typeof col === 'symbol') {
        return seperateVarNameWords(col.toString());
    } else if (typeof col === 'string') {
        return seperateVarNameWords(col)
    } else {
        return col.toString();
    }
}
function resetSort() {
    sortCols.value = props.DefaultSortCols ?? [] as number[];
    sortOrders.value = getDefaultSortOrder();
    updateSorted();
}
function getStrFromDisplayable(x: T, v: T[DisplayableKeys<T>]): string {
    return (v instanceof Function) ? v.call(x) : v?.toString() ?? '';
}
function keyValueIncFilterStr(x: T, k: DisplayableKeys<T>, f: string) {
    const v = x[k];
    //if (typeof v==='number') return v === +f;
    const str = getStrFromDisplayable(x, v);
    return str.toLowerCase().includes(f.toLowerCase());
}
function stateValNonNullsGuard<K extends DisplayableKeys<T>,V>(v: [K,V|undefined]): v is [K,V] {
    return !!v[1];
}
function filterValNonNullsGuard<K extends DisplayableKeys<T>,V>(v: [K,V|undefined]): v is [K,V] {
    if (nullFilterStates.value[v[0]]===NullFilterState.NullOnly) return false;
    return !!v[1];
}
function* yieldFilteredItems(pairIterator: IterableIterator<[T[NonNullableK<T, K>], T]>, filteredNullFilterStates: [DisplayableKeys<T, keyof T>, NullFilterState][], filteredFilter: [DisplayableKeys<T, keyof T>, string][]) {
    for (const [rowKey, x] of pairIterator) {
        if (!(filteredNullFilterStates.some(([k,s])=> {
            const notEmpty = !getStrFromDisplayable(x, x[k]);
            return s===NullFilterState.NullOnly ? !notEmpty : notEmpty;
        })|| filteredFilter.some(([k,f])=>!keyValueIncFilterStr(x, k as DisplayableKeys<T>, f)))) {
            yield [rowKey, x];
        }
    }
}
function filterCheckedItems() {
    const pairIterator = checkedItems.value?.entries();
    if (pairIterator) {
        //log?.debug(getChecked.name, checkedItems.value);
        const filteredNullFilterStates = (Object.entries(nullFilterStates.value) as [DisplayableKeys<T>, NullFilterState|undefined][]).filter(stateValNonNullsGuard);
        const filteredFilter = (Object.entries(filter.value) as [DisplayableKeys<T>, string|undefined][]).filter(filterValNonNullsGuard);
        return [...yieldFilteredItems(pairIterator, filteredNullFilterStates, filteredFilter)]
    }
    return [];
}
function filterWrappedRows(rows: WrappedRow<T>[]) {
    const filteredNullFilterStates = (Object.entries(nullFilterStates.value) as [DisplayableKeys<T>, NullFilterState|undefined][]).filter(stateValNonNullsGuard);
    rows = filteredNullFilterStates.length ? rows.filter(
        x=>!filteredNullFilterStates.some(([k,s])=> {
            const notEmpty = !getStrFromDisplayable(x.value, x.value[k]);
            return s===NullFilterState.NullOnly ? !notEmpty : notEmpty;
        })
    ) : rows;
    const filteredFilter = (Object.entries(filter.value) as [DisplayableKeys<T>, string|undefined][]).filter(filterValNonNullsGuard);
    rows =  filteredFilter.length ? rows.filter(
        x=>!filteredFilter.some(([k,f])=>!keyValueIncFilterStr(x.value, k, f))
    ) : rows;
    return rows;
}
function onFilterChangeOK(col: DisplayableKeys<T>, newF: string) {
    filterShown.value = undefined;
    filter.value[col] = newF;
    // make sure this is called when loadCallBack is defined
    if (props.LoadDataCallBack) {
        resetPage();
    } else {
        onFilterChangeLocalRows(col, newF);
    }
}
function onFilterChangeLocalRows(col: DisplayableKeys<T>, newF: string) {
    const oldF = filter.value[col];
    filter.value[col] = newF;
    if ((oldF?.length ?? 0) < newF.length) {
        applyFilterInc();
    }
    else if (oldF !== newF) {
        applyFilter();
    }
}
function applyFilter() {
    filteredRows.value = filterWrappedRows(sortedRows.value);
}
function applyFilterInc() {
    filteredRows.value = filterWrappedRows(filteredRows.value);
}
function resetFilter() {
    filter.value = {};
    filterShown.value = undefined;
    filteredRows.value = sortedRows.value;
}
function colFilterDisabled(col: keyof T) {
    return props.DisableFilter || props.NonFilterableColumns?.includes(col);
}
function togFilInpAtCol(i: number) {
    filterShown.value === i ? (filterShown.value = undefined) : (filterShown.value = i);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["vtl-table-wrapper", {empty:!showingFullTable.value, shrink:showingLoading.value}])
    }, [
      _createElementVNode("div", {
        ref_key: "detector",
        ref: detector,
        class: "detector"
      }, null, 512),
      _hoisted_2,
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("thead", null, [
          (_ctx.ColumnGroups)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ColumnGroups, (group) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: group.header,
                    colspan: group.columns.length,
                    class: _normalizeClass(['vtl-grouped-header', { 'has-header-title': group.header !== '' }])
                  }, _toDisplayString(group.header), 11, _hoisted_5))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("tr", null, [
            _renderSlot(_ctx.$slots, "pre-col-header"),
            (_ctx.HasCheckBox && !_ctx.SingleSelection)
              ? (_openBlock(), _createElementBlock("th", _hoisted_6, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    disabled: nothingToCheck.value,
                    checked: allChecked.value,
                    onClick: checkAll
                  }, null, 8, _hoisted_7)
                ]))
              : _createCommentVNode("", true),
            (_ctx.SingleSelection && _ctx.HasCheckBox)
              ? (_openBlock(), _createElementBlock("th", _hoisted_8))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Cols, (col, i) => {
              return (_openBlock(), _createElementBlock("th", {
                key: i,
                class: _normalizeClass({ minwidth: minWidthCols.value ? minWidthCols.value[i] : false, overflow: overflow.value })
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", {
                        class: _normalizeClass(['vtl-header-content', { clickable:!colFilterDisabled(col) }]),
                        onClick: ($event: any) => (colFilterDisabled(col) ? undefined : togFilInpAtCol(i))
                      }, [
                        _renderSlot(_ctx.$slots, `${slotKeys.value[i]}-header`, { value: col }, () => [
                          _createTextVNode(_toDisplayString(labels.value[i]), 1)
                        ]),
                        (filter.value[col]||nullFilterStates.value[col])
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                              _createTextVNode("  "),
                              _createVNode(Filter, { class: "vtl-filter-icon" })
                            ]))
                          : _createCommentVNode("", true)
                      ], 10, _hoisted_12),
                      (!_ctx.DisableSort)
                        ? (_openBlock(), _createBlock(ArrowUpDown, {
                            key: 0,
                            class: "vtl-sortable",
                            "model-value": sortCols.value.indexOf(i) >= 0 ? sortOrders.value[sortCols.value.indexOf(i)] === 1 ? _unref(ArrowState).UP : _unref(ArrowState).DOWN : _unref(ArrowState).BOTH,
                            onClick: ($event: any) => (sortBy(i as number))
                          }, null, 8, ["model-value", "onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  ((_ctx.LoadDataCallBack || !isLoading.value && !_unref(err)) && filterShown.value === i)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _hoisted_16,
                          _createVNode(MultiStateSVGButton, {
                            modelValue: nullFilterStates.value[col],
                            "onUpdate:modelValue": [
                              ($event: any) => ((nullFilterStates.value[col]) = $event),
                              _cache[0] || (_cache[0] = ($event: any) => (_ctx.LoadDataCallBack?resetPage():applyFilter()))
                            ],
                            states: nullFilterSVGs,
                            title: nullFilterBtnTitles[nullFilterStates.value[col]??0]
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "title"])
                        ]),
                        (_ctx.LoadDataCallBack)
                          ? (_openBlock(), _createElementBlock("form", {
                              key: 0,
                              class: "vtl-filter-input-cont",
                              onSubmit: _withModifiers(e=>onFilterChangeOK(col,((e.target as HTMLFormElement).children[0] as HTMLInputElement).value), ["prevent"])
                            }, [
                              _createElementVNode("input", {
                                disabled: nullFilterStates.value[col]===NullFilterState.NullOnly,
                                value: filter.value[col]
                              }, null, 8, _hoisted_18),
                              _hoisted_19
                            ], 40, _hoisted_17))
                          : (_openBlock(), _createElementBlock("input", {
                              key: 1,
                              value: filter.value[col],
                              disabled: nullFilterStates.value[col]===NullFilterState.NullOnly,
                              onVnodeMounted: _cache[1] || (_cache[1] = e=>(e.el as HTMLElement).focus()),
                              onInput: e=>onFilterChangeLocalRows(col,(e.target as HTMLInputElement).value),
                              onKeypress: _cache[2] || (_cache[2] = e=>{if(e.key==='Enter')filterShown.value=undefined;})
                            }, null, 40, _hoisted_20))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 2))
            }), 128)),
            _renderSlot(_ctx.$slots, "post-col-header")
          ])
        ]),
        (!(_ctx.HideTable || showingLoading.value))
          ? (_openBlock(), _createBlock(_TransitionGroup, {
              key: 0,
              name: _ctx.TableName,
              tag: "tbody"
            }, {
              default: _withCtx(() => [
                (_unref(err))
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                      _createElementVNode("td", { colspan: nDisplayCols.value }, "Error at loading data... Try refreshing the page... ", 8, _hoisted_22)
                    ]))
                  : (!isLoading.value && numRecords.value == 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [
                        _createElementVNode("td", { colspan: nDisplayCols.value }, _toDisplayString(_ctx.NoDataAvailableMessage), 9, _hoisted_24)
                      ]))
                    : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageRows.value, (row, i) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                    _createElementVNode("tr", {
                      class: _normalizeClass(['striped', { 'vtl-checked': row.checked, clickable:!!_ctx.RowClickedCallBack, 'highlightable': (_ctx.HasCheckBox || _ctx.RowClickedCallBack) }]),
                      onClick: ($event: any) => (_ctx.RowClickedCallBack?.(row.value)),
                      title: _ctx.RowTitle?.(row.value)
                    }, [
                      _renderSlot(_ctx.$slots, "pre-col", {
                        value: row.value
                      }),
                      (_ctx.HasCheckBox)
                        ? (_openBlock(), _createElementBlock("td", {
                            key: 0,
                            class: "vtl-checkbox",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (disableEventPropagation($event)))
                          }, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              value: _ctx.ColKey ? row.value[_ctx.ColKey as (keyof T)] : i,
                              disabled: _ctx.RowCheckableFilter?.(row.value) === false,
                              checked: row.checked,
                              onChange: ($event: any) => (_ctx.SingleSelection ? updateSingleCheck(row) : checkRow(row))
                            }, null, 40, _hoisted_26)
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Cols, (col, j) => {
                        return (_openBlock(), _createElementBlock("td", {
                          key: j,
                          class: _normalizeClass([col, { overflow: overflow.value }])
                        }, [
                          _renderSlot(_ctx.$slots, slotKeys.value[j], {
                            value: row.value
                          }, () => [
                            (Array.isArray(col))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(col.map(key => row.value[key]).join(' ')), 1))
                              : (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(access(row.value,col)), 1))
                          ])
                        ], 2))
                      }), 128)),
                      _renderSlot(_ctx.$slots, "post-col", {
                        value: row.value
                      })
                    ], 10, _hoisted_25),
                    _renderSlot(_ctx.$slots, "post-row", {
                      value: row.value
                    })
                  ], 64))
                }), 128)),
                (_ctx.SummaryCols!=null && _ctx.SummaryValues!=null)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_29, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Cols, (col, j) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: j }, [
                          (j === 0)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_30, [
                                _createElementVNode("strong", _hoisted_31, _toDisplayString(_ctx.SummaryLabel?? "Total:"), 1)
                              ]))
                            : (_ctx.SummaryCols.includes(col))
                              ? (_openBlock(), _createElementBlock("td", _hoisted_32, [
                                  _createElementVNode("strong", _hoisted_33, _toDisplayString(_unref(MonetaryValueWithCommas)(_ctx.SummaryValues[_ctx.SummaryCols.indexOf(col)])), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("td", _hoisted_34))
                        ], 64))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "post-table")
              ]),
              _: 3
            }, 8, ["name"]))
          : _createCommentVNode("", true)
      ]),
      (showPagingInfo.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
            (!_ctx.MiniPaging)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, _toDisplayString(stringFormat(_ctx.PagingInfoMessage, rowStart.value, rowEnd.value, numRecords.value)), 1)
                  ]),
                  _createElementVNode("ul", _hoisted_38, [
                    _createElementVNode("li", {
                      class: _normalizeClass(["page-item", { disabled: _unref(page) <= 1 }])
                    }, [
                      _createElementVNode("div", {
                        class: "page-link",
                        "aria-label": "Previous",
                        onClick: prevPage
                      }, _hoisted_41)
                    ], 2),
                    _createElementVNode("li", {
                      class: _normalizeClass(["page-item", { active: _unref(page) === 1 }])
                    }, [
                      _createElementVNode("div", {
                        class: "page-link",
                        "aria-label": "First",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (movePage(1)))
                      }, _hoisted_43)
                    ], 2),
                    (pageSwitch.value.start > 3)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_44, _hoisted_46))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageSwitch.value.num, (n) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: _normalizeClass(["page-item", { active: _unref(page) === pageSwitch.value.start + n - 1 }]),
                        key: pageSwitch.value.start + n - 1
                      }, [
                        _createElementVNode("div", {
                          class: "page-link",
                          onClick: ($event: any) => (movePage(pageSwitch.value.start + n - 1))
                        }, _toDisplayString(pageSwitch.value.start + n - 1), 9, _hoisted_47)
                      ], 2))
                    }), 128)),
                    (pageSwitch.value.end < maxPage.value - 2)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_48, _hoisted_50))
                      : _createCommentVNode("", true),
                    _createElementVNode("li", {
                      class: _normalizeClass(["page-item", { active: _unref(page) === maxPage.value }])
                    }, [
                      _createElementVNode("div", {
                        class: "page-link",
                        "aria-label": "Max",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (movePage(maxPage.value)))
                      }, [
                        _createElementVNode("span", _hoisted_51, _toDisplayString(maxPage.value), 1)
                      ])
                    ], 2),
                    _createElementVNode("li", {
                      class: _normalizeClass(["page-item", { disabled: _unref(page) >= maxPage.value }])
                    }, [
                      _createElementVNode("div", {
                        class: "page-link",
                        "aria-label": "Next",
                        onClick: nextPage
                      }, _hoisted_54)
                    ], 2)
                  ])
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(['vtl-paging-change', { 'col-md-4':!_ctx.MiniPaging } ])
            }, [
              _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.PageSizeChangeLabel), 1),
              _withDirectives(_createElementVNode("select", {
                class: "vtl-paging-count",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(rowsPerPage) ? (rowsPerPage).value = $event : null)),
                onChange: _cache[7] || (_cache[7] = ($event: any) => (loadDataIfCallBack()))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.PageOptions as Array<number>), (pageOption) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: pageOption,
                    key: pageOption
                  }, _toDisplayString(pageOption), 9, _hoisted_56))
                }), 128))
              ], 544), [
                [_vModelSelect, _unref(rowsPerPage)]
              ]),
              _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.GotoPageLabel), 1),
              _withDirectives(_createElementVNode("select", {
                class: "vtl-paging-page",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
                onChange: _cache[9] || (_cache[9] = ($event: any) => (movePage(_unref(page))))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(maxPage.value, (n) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: n,
                    value: n
                  }, _toDisplayString(n), 9, _hoisted_58))
                }), 128))
              ], 544), [
                [_vModelSelect, _unref(page)]
              ])
            ], 2)
          ]))
        : (!(_ctx.HideTable || showingLoading.value || _ctx.DisablePaging) && numRecords.value > rowsPerPageInitial.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
              (!_ctx.MiniPaging)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("div", _hoisted_61, _toDisplayString(stringFormat(_ctx.PagingInfoMessage, rowStart.value, rowEnd.value, numRecords.value)), 1)
                    ]),
                    _hoisted_62
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(['vtl-paging-change', { 'col-md-4':!_ctx.MiniPaging } ])
              }, [
                _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.PageSizeChangeLabel), 1),
                _withDirectives(_createElementVNode("select", {
                  class: "vtl-paging-count",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_isRef(rowsPerPage) ? (rowsPerPage).value = $event : null)),
                  onChange: loadDataIfCallBack
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.PageOptions as Array<number>), (pageOption) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: pageOption,
                      key: pageOption
                    }, _toDisplayString(pageOption), 9, _hoisted_64))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _unref(rowsPerPage)]
                ]),
                _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.GotoPageLabel), 1),
                _withDirectives(_createElementVNode("select", {
                  class: "vtl-paging-page",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
                  onChange: _cache[12] || (_cache[12] = ($event: any) => (movePage(_unref(page))))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(maxPage.value, (n) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: n,
                      value: n
                    }, _toDisplayString(n), 9, _hoisted_66))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _unref(page)]
                ])
              ], 2)
            ]))
          : (_ctx.ShowTableCount && !(_ctx.HideTable || showingLoading.value || _ctx.DisablePaging) && maxPage.value == 1 && numRecords.value != 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                (!_ctx.MiniPaging)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                      _createElementVNode("div", _hoisted_69, _toDisplayString(stringFormat(_ctx.PagingInfoMessage, rowStart.value, rowEnd.value, numRecords.value)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
    ], 2),
    _withDirectives(_createVNode(Spinner, null, null, 512), [
      [_vShow, showingLoading.value]
    ]),
    (sticky.value && showingFullTable.value)
      ? (_openBlock(), _createBlock(ScrollToTopButton, { key: 0 }))
      : _createCommentVNode("", true)
  ], 512))
}
}

})